import { createFileRoute, redirect } from '@tanstack/react-router';
import * as z from 'zod';
import { BRANCH_MODERATIONS } from '@/entities/branch';
import { requireAuth } from '../require-auth';

const branchesSearchSchema = z.object({
  status: z.enum(BRANCH_MODERATIONS).optional().catch(undefined),
});

export const Route = createFileRoute('/eats/branches')({
  beforeLoad: (ctx) => {
    requireAuth();
    const search = ctx.search as { status?: string };
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/eats/menu',
      search: {
        section: 'branches',
        ...(search?.status ? { status: search.status } : {}),
      },
      replace: true,
    });
  },
  validateSearch: branchesSearchSchema,
});
